e4.ecom.checkout = {
    debug: false,
    init: function () {
        if ( jQuery( '.js-e-checkout' ).length === 1 ) {
            e4.util.require.js( e4.settings.require.handlebars, function () {
                e4.ecom.checkout.handlebars.registerHelpers();
                e4.ecom.checkout.handlebars.registerPartials();
                e4.ecom.checkout.handlebars.compileTemplate();
                e4.ecom.checkout.bindEvents();
            } );

        }
        if ( jQuery( '.js-e-checkout-receipt' ).length === 1 ) {
            e4.ecom.checkout.steps.receipt.init();
        }
    },
    handlebars: {
        orderTmpl: null,
        cartTmpl: null,
        summeryTmpl: null,
        glsResultsTmpl: null,
        pacsoftResultsTmpl: null,
        registerHelpers: function () {
            if ( window.Handlebars.helpers.compare === undefined ) {
                Handlebars.registerHelper( 'compare', function ( v1, operator, v2, options ) {
                    switch ( operator ) {
                    case '===':
                        return ( v1 === v2 ) ? options.fn( this ) : options.inverse( this );
                    case '!==':
                        return ( v1 !== v2 ) ? options.fn( this ) : options.inverse( this );
                    case '<':
                        return ( v1 < v2 ) ? options.fn( this ) : options.inverse( this );
                    case '<=':
                        return ( v1 <= v2 ) ? options.fn( this ) : options.inverse( this );
                    case '>':
                        return ( v1 > v2 ) ? options.fn( this ) : options.inverse( this );
                    case '>=':
                        return ( v1 >= v2 ) ? options.fn( this ) : options.inverse( this );
                    case '&&':
                        return ( v1 && v2 ) ? options.fn( this ) : options.inverse( this );
                    case '||':
                        return ( v1 || v2 ) ? options.fn( this ) : options.inverse( this );
                    default:
                        return options.inverse( this );
                    }
                } );

            }
            if ( window.Handlebars.helpers.counter === undefined ) {
                Handlebars.registerHelper( 'counter', function ( index ) {
                    return index + 1;
                } );
            }
        },
        registerPartials: function () {
            Handlebars.registerPartial( 'glsResults', jQuery( '#e-gls-handlebars-partial' ).html() );
            Handlebars.registerPartial( 'pacsoftResults', jQuery( '#e-pacsoft-handlebars-partial' ).html() );
            var glsResultsTmpl = jQuery( '#e-gls-handlebars-partial' ).html(),
                pacsoftResultsTmpl = jQuery( '#e-pacsoft-handlebars-partial' ).html();
            e4.ecom.checkout.handlebars.glsResultsTmpl = Handlebars.compile( glsResultsTmpl );
            e4.ecom.checkout.handlebars.pacsoftResultsTmpl = Handlebars.compile( pacsoftResultsTmpl );

        },
        compileTemplate: function () {
            var orderTmpl = jQuery( '#e-checkout-handlebars-template' ).html(),
                cartTmpl = jQuery( '#e-cart-handlebars-template' ).html(),
                summeryTmpl = jQuery( '#e-summery-handlebars-template' ).html();
            e4.ecom.checkout.handlebars.orderTmpl = Handlebars.compile( orderTmpl );
            e4.ecom.checkout.handlebars.cartTmpl = Handlebars.compile( cartTmpl );
            e4.ecom.checkout.handlebars.summeryTmpl = Handlebars.compile( summeryTmpl );
        }
    },
    bindEvents: function () {
        jQuery( window ).on( 'hashchange', function () {
            var hashStep = e4.util.hash.get( 'step' );
            if ( hashStep !== undefined ) {
                e4.ecom.checkout.order.get( hashStep, e4.settings.ecom.checkout.delay );
            }
        } );

        if ( e4.util.hash.get( 'step' ) === undefined ) {
            e4.util.hash.replace( 'step', e4.ecom.checkout.steps.first );
        }
        else {
            jQuery( window ).triggerHandler( 'hashchange' );
        }

        jQuery( '.js-e-checkout' ).on( 'hidden.bs.collapse', '.collapse', function () {
            if ( e4.ecom.checkout.steps.current !== e4.ecom.checkout.steps.target ) {
                if ( Math.max( jQuery( window ).width(), window.innerWidth ) > e4.settings.breakpoint[ e4.settings.ecom.checkout.multipageBreakpoint ] ) {
                    e4.scrollToAnchor.animate( e4.scrollToAnchor.getTarget( '.js-e-checkout-step[data-step="' + e4.ecom.checkout.steps.target + '"]:first' ) - jQuery( '.js-e-header' ).height() );
                }
                else {
                    jQuery( window ).scrollTop( 0 );
                }
            }
            e4.ecom.checkout.steps.current = e4.ecom.checkout.steps.target;
        } ).on( 'show.bs.collapse', '.collapse', function () {
            if ( e4.ecom.checkout.steps.direction !== null ) {
                jQuery( '.collapse' ).addClass( 'e-checkout-direction-' + e4.ecom.checkout.steps.direction );
            }
        } ).on( 'shown.bs.collapse', '.collapse', function ( event ) {
            jQuery( event.currentTarget ).find( 'form' ).validate();
        } );

        jQuery( '.js-e-checkout' ).on( 'change', '.js-e-checkout-toggle-field', function ( event ) {
            event.preventDefault();
            var jToggleField = jQuery( this ).val(),
                jTarget = jQuery( '.js-e-checkout-toggle-target[data-target="' + jToggleField + '"]' );
            jTarget.slideToggle( e4.settings.animation.speed );
            if ( jQuery( this ).is( ':checked' ) === false ) {
                jTarget.find( 'input, textarea' ).val( '' );
            }
        } );

        e4.ecom.checkout.steps.init();
        e4.ecom.checkout.cart.init();
        e4.ecom.checkout.order.init();
    },
    cart: {
        init: function () {
            e4.ecom.checkout.cart.get();
            e4.ecom.checkout.cart.bindEvents();
        },
        bindEvents: function () {
            jQuery( '.js-e-checkout' ).on( 'change', '.js-e-checkout-update-cart', function () {
                e4.ecom.checkout.cart.get();
            } );
            jQuery( '.js-e-checkout' ).on( 'click', '.js-e-checkout-update-cart-btn', function () {
                e4.ecom.checkout.cart.get();
            } );
        },
        get: function () {
            jQuery.ajax( {
                    url: e4.settings.ecom.cart.url,
                    type: 'POST',
                    beforeSend: function () {
                        jQuery( '.js-e-checkout-cart-loading-overlay' ).addClass( 'is-loading' );
                    },
                    data: jQuery( '.js-e-checkout-step-form' ).serialize()
                } )
                .done( function ( data ) {
                    e4.ecom.checkout.cart.build( data );
                    if ( e4.ecom.checkout.debug === true ) {
                        console.info( data );
                    }

                } )
                .fail( function ( error ) {
                    if ( e4.ecom.checkout.debug === true ) {
                        console.error( 'Failed to fetch CART DATA, please check your settings!.' );
                        console.error( error.responseText );
                    }
                } );
        },
        build: function ( data ) {
            setTimeout( function () {
                jQuery( '#js-e-checkout-cart' ).html( e4.ecom.checkout.handlebars.cartTmpl( data ) );
                jQuery( '#js-e-checkout-modal-cart' ).html( e4.ecom.checkout.handlebars.cartTmpl( data ) );
            }, e4.settings.ecom.checkout.delay );

        }
    },
    order: {
        hasChanged: {
            payment: false,
            shipping: false
        },
        init: function () {
            e4.ecom.checkout.order.bindEvents();
        },
        bindEvents: function () {
            jQuery( '.js-e-checkout' ).on( 'change', '.js-e-checkout-update-order', function () {
                var jStep = jQuery( this ).closest( '.js-e-checkout-step' ).data( 'step' );
                if ( jStep !== e4.util.hash.get( 'step' ) ) {
                    e4.util.hash.set( 'step', jStep );
                }
                else {
                    jQuery( window ).triggerHandler( 'hashchange' );
                }
            } );
        },
        get: function ( step, delay ) {
            e4.ecom.checkout.steps.target = step;
            jQuery( '.js-e-checkout-step-previous' ).val( e4.ecom.checkout.steps.current );
            jQuery( '.js-e-checkout-step-current' ).val( e4.ecom.checkout.steps.target );
            jQuery( '.js-e-checkout-step-index' ).val( e4.ecom.checkout.steps.map[ e4.ecom.checkout.steps.target ] );

            jQuery.ajax( {
                    url: e4.settings.ecom.checkout.url,
                    type: 'POST',
                    beforeSend: function () {
                        jQuery( '.js-e-checkout-step-loading-overlay' ).addClass( 'is-loading' );
                    },
                    data: jQuery( '.js-e-checkout-step-form' ).serialize()
                } )
                .done( function ( data ) {
                    e4.ecom.checkout.order.dataHandler( data, e4.ecom.checkout.steps.target, delay );
                    if ( e4.ecom.checkout.debug === true ) {
                        console.info( data );
                    }

                } )
                .fail( function ( error ) {
                    if ( e4.ecom.checkout.debug === true ) {
                        console.error( 'Failed to fetch ORDER DATA, please check your settings!' );
                        console.error( error.responseText );
                    }

                } );
        },
        dataHandler: function ( data, step, delay ) {
            if ( data.steps.shipping.hasChanged === true ) {
                e4.ecom.checkout.order.hasChanged.shipping = data.steps.shipping.hasChanged;
                data.steps.shipping.hasChanged = 'e-checkout-step-has-changed';
            }
            if ( data.steps.payment.hasChanged === true ) {
                e4.ecom.checkout.order.hasChanged.payment = data.steps.payment.hasChanged;
                data.steps.payment.hasChanged = 'e-checkout-step-has-changed';
            }
            if ( data.steps.shipping.shippingmethodID === e4.settings.ecom.checkout.shipping.glsID ) {
                data.steps.shipping.isGLS = true;
                data.steps.shipping.isPacsoft = false;
                data.steps.shipping.isStandard = false;
                data.steps.customer.alternativeBillingAddress = true;
            }
            else if ( data.steps.shipping.shippingmethodID === e4.settings.ecom.checkout.shipping.pacsoftID ) {
                data.steps.shipping.isPacsoft = true;
                data.steps.shipping.isStandard = false;
                data.steps.shipping.isGLS = false;
                data.steps.customer.alternativeBillingAddress = true;
            }
            else {
                data.steps.shipping.isStandard = true;
                data.steps.shipping.isPacsoft = false;
                data.steps.shipping.isGLS = false;
            }
            e4.ecom.checkout.order.build( data, step, delay );
        },
        build: function ( data, step, delay ) {
            setTimeout( function () {
                jQuery( '#js-e-checkout-form' ).html( e4.ecom.checkout.handlebars.orderTmpl( data ) );
                jQuery( '#js-e-checkout-modal-summery' ).html( e4.ecom.checkout.handlebars.summeryTmpl( data ) );
                jQuery( '.js-e-checkout-loading-overlay' ).fadeOut( 'slow' );
                e4.ecom.checkout.steps.handler.switch();
                e4.ecom.checkout.tracking.step( data.steps[ e4.ecom.checkout.steps.current ] );
            }, delay );
        }

    },
    steps: {
        first: 'shipping',
        current: 'shipping',
        target: null,
        map: {
            shipping: 1,
            customer: 2,
            payment: 3,
            approve: 4
        },
        direction: null,
        init: function () {
            e4.ecom.checkout.steps.handler.init();
            e4.ecom.checkout.steps.shipping.init();
            e4.ecom.checkout.steps.customer.init();
            e4.ecom.checkout.steps.payment.init();
            e4.ecom.checkout.steps.approve.init();

        },
        addressMapper: function ( jParent, mappingObj ) {
            jQuery.each( mappingObj, function ( key, value ) {
                jParent.find( 'input[name="' + key + '"]' ).val( value );
            } );
        },
        handler: {
            init: function () {
                e4.ecom.checkout.steps.handler.next();
                e4.ecom.checkout.steps.handler.edit();
            },
            switch: function () {
                e4.ecom.checkout.steps.handler.methodChange( e4.ecom.checkout.steps.current );
                var jCollapse = jQuery( '#js-e-checkout-accordion' );
                jCollapse.find( '.collapse.js-e-checkout-collapse-hide' ).collapse( 'hide' );
                jCollapse.find( '.collapse.js-e-checkout-collapse-show' ).collapse( 'show' );

                if ( e4.ecom.checkout.steps.map[ e4.ecom.checkout.steps.target ] === undefined ) {
                    e4.util.hash.replace( 'step', e4.ecom.checkout.steps.first );
                }
                else {
                    if ( e4.ecom.checkout.steps[ e4.ecom.checkout.steps.target ].show !== undefined ) {
                        e4.ecom.checkout.steps[ e4.ecom.checkout.steps.target ].show();
                    }
                }
                jQuery( 'body' ).attr( 'class', 'e-checkout-page e-checkout-page-' + e4.ecom.checkout.steps.target );
            },
            next: function () {
                jQuery( '.js-e-checkout' ).on( 'click', '.js-e-checkout-change-step', function ( event ) {
                    event.preventDefault();
                    var jStep = jQuery( this ).data( 'target' ).replace( '#', '' ),
                        jForm = jQuery( this ).closest( 'form' );
                    if ( jForm.valid() === true ) {
                        e4.ecom.checkout.steps.direction = 'next';
                        e4.util.hash.set( 'step', jStep );
                    }
                } );
            },
            methodChange: function ( step ) {
                if ( step === 'payment' || step === 'shipping' ) {
                    jQuery( '.js-e-checkout-step[data-step="' + step + '"]' ).removeClass( 'e-checkout-step-has-changed' );
                    e4.ecom.checkout.order.hasChanged[ step ] = false;
                    //TODO - open and scroll to first step with issue if current step is valid
                }
            },
            edit: function () {
                jQuery( '.js-e-checkout, .js-e-checkout-modal-summery' ).on( 'click', '.js-e-checkout-edit-step', function ( event ) {
                    event.preventDefault();
                    var jStep = jQuery( this ).data( 'target' ).replace( '#', '' );
                    e4.ecom.checkout.steps.target = jStep;
                    e4.ecom.checkout.steps.direction = 'previous';
                    e4.util.hash.set( 'step', jStep );
                } );
            }
        },
        customer: {
            init: function () {
                e4.ecom.checkout.steps.customer.alternativeBilling();
            },
            show: function () {
                if ( jQuery( '.js-e-checkout-has-alternative-billing-address:checked' ).val() === 'no' ) {
                    e4.ecom.checkout.steps.customer.mapDeliveryToBilling( jQuery( '.js-e-checkout-alternative-billing-address' ) );
                }
            },
            alternativeBilling: function () {
                jQuery( '.js-e-checkout' ).on( 'change', '.js-e-checkout-has-alternative-billing-address', function ( event ) {
                    var jAlternativeBillingAddress = jQuery( '.js-e-checkout-alternative-billing-address' );
                    if ( jQuery( this ).is( ':checked' ) === true && jQuery( this ).val() === 'yes' ) {
                        if ( event.isTrigger === undefined ) {
                            e4.ecom.checkout.steps.customer.clear();
                        }
                        jAlternativeBillingAddress.collapse( 'show' );
                        e4.scrollToAnchor.animate( e4.scrollToAnchor.getTarget( '.js-e-checkout-alternative-billing-address' ) );

                    }
                    else {
                        jAlternativeBillingAddress.collapse( 'hide' );
                        e4.ecom.checkout.steps.customer.mapDeliveryToBilling( jAlternativeBillingAddress );
                    }
                } );
            },
            mapDeliveryToBilling: function ( jAlternativeBillingAddress ) {
                var mappingObj = {
                    EcomOrderCustomerName: jQuery( 'input[name="EcomOrderDeliveryName"]' ).val(),
                    EcomOrderCustomerCompany: jQuery( 'input[name="EcomOrderDeliveryCompany"]' ).val(),
                    EcomOrderCustomerAddress: jQuery( 'input[name="EcomOrderDeliveryAddress"]' ).val(),
                    EcomOrderCustomerAddress2: jQuery( 'input[name="EcomOrderDeliveryAddress2"]' ).val(),
                    EcomOrderCustmerZip: jQuery( 'input[name="EcomOrderDeliveryZip"]' ).val(),
                    EcomOrderCustomerCity: jQuery( 'input[name="EcomOrderDeliveryCity"]' ).val(),
                    EcomOrderCustomerPhone: jQuery( 'input[name="EcomOrderDeliveryPhone"]' ).val()
                };
                e4.ecom.checkout.steps.addressMapper( jAlternativeBillingAddress, mappingObj );
            },
            clear: function () {
                jQuery( '.js-e-checkout-alternative-billing-address' ).find( 'input[type="text"]' ).val( '' );
                jQuery( '.js-e-checkout-alternative-billing-address' ).find( 'input[type="checkbox"]' ).prop( 'checked', false );
            }
        },
        payment: {
            init: function () {}
        },
        shipping: {
            selected: null,
            init: function () {
                e4.ecom.checkout.steps.shipping.bindEvents();
            },
            show: function () {
                e4.ecom.checkout.steps.shipping.gls.init();
                e4.ecom.checkout.steps.shipping.pacsoft.init();
            },
            clear: function () {
                var jDeliveryForm = jQuery( '.js-e-checkout-delivery-address' );
                jDeliveryForm.find( 'input[type="text"]' ).val( '' );
                jDeliveryForm.find( 'input[type="checkbox"]' ).prop( 'checked', false );
                jDeliveryForm.find( '.js-e-checkout-toggle-target' ).hide();
            },
            bindEvents: function () {
                jQuery( '.js-e-checkout' ).on( 'change', '.js-e-checkout-shipping-method', function () {
                    var jShippingID = jQuery( this ).val();
                    if ( jShippingID === e4.settings.ecom.checkout.shipping.pacsoftID ) {
                        e4.ecom.checkout.steps.shipping.pacsoft.show();
                        e4.ecom.checkout.steps.shipping.gls.hide();
                        e4.ecom.checkout.steps.shipping.standard.hide();
                        jQuery( '.js-e-checkout-shipping-type' ).val( 'pacsoft' );
                    }
                    else if ( jShippingID === e4.settings.ecom.checkout.shipping.glsID ) {
                        e4.ecom.checkout.steps.shipping.gls.show();
                        e4.ecom.checkout.steps.shipping.pacsoft.hide();
                        e4.ecom.checkout.steps.shipping.standard.hide();
                        jQuery( '.js-e-checkout-shipping-type' ).val( 'gls' );
                    }
                    else {
                        e4.ecom.checkout.steps.shipping.pacsoft.hide();
                        e4.ecom.checkout.steps.shipping.gls.hide();
                        e4.ecom.checkout.steps.shipping.standard.show();
                        jQuery( '.js-e-checkout-shipping-type' ).val( 'standard' );
                    }
                } );
                jQuery( '.js-e-checkout' ).on( 'click', '.js-e-checkout-shippingmethod-pacsoft-lookup-btn', function () {
                    jQuery( '.js-e-checkout-shippingmethod-pacsoft-zip' ).trigger( 'keyup' );
                } );
                jQuery( '.js-e-checkout' ).on( 'click', '.js-e-checkout-shippingmethod-gls-lookup-btn', function () {
                    jQuery( '.js-e-checkout-shippingmethod-gls-zip' ).trigger( 'keyup' );
                } );
                jQuery( '.js-e-checkout' ).on( 'click', '.js-e-checkout-shippingmethod-gls-result-item', function () {
                    var parcelShopID = jQuery( this ).val();
                    e4.ecom.checkout.steps.shipping.gls.set( parcelShopID );
                } );
                jQuery( '.js-e-checkout' ).on( 'click', '.js-e-checkout-shippingmethod-pacsoft-result-item', function () {
                    var servicePointID = jQuery( this ).val();
                    e4.ecom.checkout.steps.shipping.pacsoft.set( servicePointID );
                } );
            },
            standard: {
                init: function () {

                },
                show: function () {
                    jQuery( '.js-e-checkout-delivery-address' ).collapse( 'show' );
                },
                hide: function () {
                    jQuery( '.js-e-checkout-delivery-address' ).collapse( 'hide' );
                    e4.ecom.checkout.steps.shipping.clear();
                }
            },
            pacsoft: {
                init: function () {
                    e4.ecom.checkout.steps.shipping.pacsoft.bindEvents();
                },
                show: function () {
                    jQuery( '.js-e-checkout-shippingmethod-pacsoft' ).collapse( 'show' );
                },
                hide: function () {
                    jQuery( '.js-e-checkout-shippingmethod-pacsoft' ).collapse( 'hide' );
                    e4.ecom.checkout.steps.shipping.pacsoft.clear();
                },
                clear: function () {
                    e4.ecom.checkout.steps.shipping.clear();
                    jQuery( '.js-e-checkout-shippingmethod-pacsoft-id' ).val( '' );
                    e4.ecom.checkout.steps.shipping.pacsoft.data = null;
                    jQuery( '#js-e-checkout-shippingmethod-pacsoft-results' ).slideUp( e4.settings.animation.speed, function () {
                        jQuery( this ).html( '' );
                    } );
                },
                bindEvents: function () {
                    jQuery( '.js-e-checkout-shippingmethod-pacsoft-zip' ).on( 'keyup', function () {
                        var jSearchValue = jQuery( this ).val();
                        if ( jSearchValue.length > 3 ) {
                            e4.ecom.checkout.steps.shipping.pacsoft.search( jSearchValue );
                        }
                        else {
                            e4.ecom.checkout.steps.shipping.pacsoft.clear();
                        }
                    } );
                    jQuery( '.js-e-checkout-shippingmethod-pacsoft-edit-btn' ).on( 'click', function ( event ) {
                        event.preventDefault();
                        e4.ecom.checkout.steps.shipping.pacsoft.clear();
                        jQuery( window ).triggerHandler( 'hashchange' );

                    } );
                },
                set: function ( servicePointID ) {
                    var jAlternativeShippingAddress = jQuery( '.js-e-checkout-delivery-address' );
                    for ( var i = 0; i < e4.ecom.checkout.steps.shipping.pacsoft.data.servicePoints.length; i++ ) {
                        e4.ecom.checkout.steps.shipping.pacsoft.data.servicePoints[ i ].isSelected = '';
                        if ( e4.ecom.checkout.steps.shipping.pacsoft.data.servicePoints[ i ].servicePointId === servicePointID ) {
                            var mappingObj = {
                                EcomOrderDeliveryName: e4.ecom.checkout.steps.shipping.pacsoft.data.servicePoints[ i ].name,
                                EcomOrderDeliveryCompany: e4.ecom.checkout.steps.shipping.pacsoft.data.servicePoints[ i ].name,
                                EcomOrderDeliveryAddress: e4.ecom.checkout.steps.shipping.pacsoft.data.servicePoints[ i ].deliveryAddress.streetName + ' ' + e4.ecom.checkout.steps.shipping.pacsoft.data.servicePoints[ i ].deliveryAddress.streetNumber,
                                EcomOrderDeliveryZip: e4.ecom.checkout.steps.shipping.pacsoft.data.servicePoints[ i ].deliveryAddress.postalCode,
                                EcomOrderDeliveryCity: e4.ecom.checkout.steps.shipping.pacsoft.data.servicePoints[ i ].deliveryAddress.city
                            };
                            e4.ecom.checkout.steps.addressMapper( jAlternativeShippingAddress, mappingObj );
                            jQuery( '.js-e-checkout-shippingmethod-pacsoft-id' ).val( e4.ecom.checkout.steps.shipping.pacsoft.data.servicePoints[ i ].servicePointId );
                        }

                    }
                },
                search: function ( pacsoftZip ) {
                    var pacsoftAddress = jQuery( '.js-e-checkout-shippingmethod-pacsoft-address' ).val();
                    jQuery.ajax( {
                            url: '/pnlookup.ashx',
                            type: 'POST',
                            beforeSend: function () {
                                jQuery( '.js-e-checkout-step-loading-overlay' ).addClass( 'is-loading' );
                            },
                            data: {
                                countryCode: jQuery( '#EcomOrderDeliveryCountry' ).val(),
                                numberOfServicePoints: e4.settings.ecom.checkout.shipping.searchCount,
                                postalCode: pacsoftZip,
                                streetName: pacsoftAddress

                            }
                        } )
                        .done( function ( data ) {
                            if ( e4.ecom.checkout.debug === true ) {
                                console.info( data );
                            }
                            e4.ecom.checkout.steps.shipping.pacsoft.data = data.servicePointInformationResponse;
                            jQuery( '.js-e-checkout-step-loading-overlay' ).removeClass( 'is-loading' );
                            e4.ecom.checkout.steps.shipping.pacsoft.build();
                        } );

                },
                build: function () {
                    jQuery( '#js-e-checkout-shippingmethod-pacsoft-results' ).html( e4.ecom.checkout.handlebars.pacsoftResultsTmpl( e4.ecom.checkout.steps.shipping.pacsoft.data ) ).slideDown( e4.settings.animation.speed, function () {
                        jQuery( this ).find( '.js-e-checkout-shippingmethod-pacsoft-result-item' ).first().prop( 'checked', true ).trigger( 'click' );
                        e4.scrollToAnchor.animate( e4.scrollToAnchor.getTarget( '.js-e-checkout-shippingmethod-pacsoft' ) );
                    } );

                }
            },
            gls: {
                init: function () {
                    e4.ecom.checkout.steps.shipping.gls.bindEvents();
                },
                show: function () {
                    jQuery( '.js-e-checkout-shippingmethod-gls' ).on( 'shown.bs.collapse', function () {
                        if ( jQuery( '.js-e-checkout-shippingmethod-gls-zip' ).val() ) {
                            jQuery( '.js-e-checkout-shippingmethod-gls-zip' ).trigger( 'keyup' );
                        }
                    } ).collapse( 'show' );
                },
                hide: function () {
                    jQuery( '.js-e-checkout-shippingmethod-gls' ).collapse( 'hide' );
                    e4.ecom.checkout.steps.shipping.gls.clear();
                },
                clear: function () {
                    e4.ecom.checkout.steps.shipping.clear();
                    jQuery( '.js-e-checkout-shippingmethod-gls-id' ).val( '' );
                    e4.ecom.checkout.steps.shipping.gls.data = null;
                    jQuery( '#js-e-checkout-shippingmethod-gls-results' ).slideUp( e4.settings.animation.speed, function () {
                        jQuery( this ).html( '' );
                    } );

                },
                bindEvents: function () {
                    jQuery( '.js-e-checkout-shippingmethod-gls-zip' ).on( 'keyup', function () {
                        var jSearchValue = jQuery( this ).val();
                        if ( jSearchValue.length > 3 ) {
                            e4.ecom.checkout.steps.shipping.gls.search( jSearchValue );
                        }
                        else {
                            e4.ecom.checkout.steps.shipping.gls.clear();
                        }
                    } );
                    jQuery( '.js-e-checkout-shippingmethod-gls-edit-btn' ).on( 'click', function ( event ) {
                        event.preventDefault();
                        e4.ecom.checkout.steps.shipping.gls.clear();
                        jQuery( window ).triggerHandler( 'hashchange' );

                    } );

                },
                set: function ( parcelShopID ) {
                    var jAlternativeShippingAddress = jQuery( '.js-e-checkout-delivery-address' );
                    for ( var i = 0; i < e4.ecom.checkout.steps.shipping.gls.data.parcelshops.length; i++ ) {
                        e4.ecom.checkout.steps.shipping.gls.data.parcelshops[ i ].isSelected = '';
                        if ( e4.ecom.checkout.steps.shipping.gls.data.parcelshops[ i ].Number === parcelShopID ) {
                            var mappingObj = {
                                EcomOrderDeliveryName: e4.ecom.checkout.steps.shipping.gls.data.parcelshops[ i ].CompanyName,
                                EcomOrderDeliveryCompany: e4.ecom.checkout.steps.shipping.gls.data.parcelshops[ i ].Streetname2,
                                EcomOrderDeliveryAddress: e4.ecom.checkout.steps.shipping.gls.data.parcelshops[ i ].Streetname,
                                EcomOrderDeliveryZip: e4.ecom.checkout.steps.shipping.gls.data.parcelshops[ i ].ZipCode,
                                EcomOrderDeliveryCity: e4.ecom.checkout.steps.shipping.gls.data.parcelshops[ i ].CityName
                            };
                            e4.ecom.checkout.steps.addressMapper( jAlternativeShippingAddress, mappingObj );
                            jQuery( '.js-e-checkout-shippingmethod-gls-id' ).val( e4.ecom.checkout.steps.shipping.gls.data.parcelshops[ i ].Number );
                        }

                    }
                },
                search: function ( glsZip ) {
                    var glsAddress = jQuery( '.js-e-checkout-shippingmethod-gls-address' ).val();

                    jQuery.ajax( {
                            url: '/glslookup.ashx',
                            type: 'POST',
                            beforeSend: function () {
                                jQuery( '.js-e-checkout-step-loading-overlay' ).addClass( 'is-loading' );
                            },
                            data: {
                                count: e4.settings.ecom.checkout.shipping.searchCount,
                                type: glsAddress ? 'ADDRESS' : 'ZIP',
                                street: glsAddress,
                                zipcode: glsZip

                            }
                        } )
                        .done( function ( data ) {
                            if ( e4.ecom.checkout.debug === true ) {
                                console.info( data );
                            }
                            e4.ecom.checkout.steps.shipping.gls.data = data;
                            jQuery( '.js-e-checkout-step-loading-overlay' ).removeClass( 'is-loading' );
                            e4.ecom.checkout.steps.shipping.gls.build();
                        } );

                },
                build: function () {
                    jQuery( '#js-e-checkout-shippingmethod-gls-results' ).html( e4.ecom.checkout.handlebars.glsResultsTmpl( e4.ecom.checkout.steps.shipping.gls.data ) ).slideDown( e4.settings.animation.speed, function () {
                        jQuery( this ).find( '.js-e-checkout-shippingmethod-gls-result-item' ).first().prop( 'checked', true ).trigger( 'click' );
                        e4.scrollToAnchor.animate( e4.scrollToAnchor.getTarget( '.js-e-checkout-shippingmethod-gls' ) );
                    } );

                }
            }

        },
        approve: {
            init: function () {
                e4.ecom.checkout.steps.approve.termsAndConditions.init();
            },
            show: function () {
                jQuery( '.js-e-checkout-approve-top-panel' ).find( 'form' ).validate();
            },
            newsletterSubscription: function () {
                jQuery( '.js-e-checkout' ).on( 'change', 'input[name="Co3EspressoEcomOrderSubscribeToNewsletter"]', function () {
                    jQuery( '.js-e-checkout-approve-form' ).find( 'input[name="EcomOrderSubscribeToNewsletter"]' ).val( this.checked === true ? 'true' : '' );
                } ).triggerHandler( 'change' );
            },
            termsAndConditions: {
                init: function () {
                    e4.ecom.checkout.steps.approve.termsAndConditions.get();
                    e4.ecom.checkout.steps.approve.termsAndConditions.check();
                    e4.ecom.checkout.steps.approve.termsAndConditions.accept();
                },
                get: function () {
                    jQuery.get( e4.settings.ecom.checkout.termsAndConditions, function ( data ) {
                        var jHtml = jQuery( data ).find( '.e-content-main' ).html();
                        jQuery( '.js-e-checkout-modal-terms-and-conditions' ).replaceWith( jHtml );
                    } );
                },
                check: function () {
                    jQuery( '.js-e-checkout' ).on( 'change', 'input[name="EcomOrderCustomerAccepted"]', function () {
                        jQuery( 'input[name="EcomOrderCustomerAccepted"]' ).prop( 'checked', jQuery( this ).prop( 'checked' ) );

                    } );
                },
                accept: function () {
                    jQuery( '.js-e-accept-term-and-conditions' ).on( 'click', function () {
                        jQuery( 'input[name="EcomOrderCustomerAccepted"]' ).prop( 'checked', true );
                    } );
                }
            }
        },
        receipt: {
            init: function () {
                e4.util.hash.remove( 'step' );
                var step = {
                    index: 5,
                    name: 'receipt'
                };
                e4.ecom.checkout.tracking.step( step );
            }
        },
    },
    tracking: {
        step: function ( data ) {
            var virtualPageview = {
                'event': 'VirtualPageview',
                'vpevent': 'VirtualPageview',
                'virtualPageURL': '/shop/cart/checkout?step=' + data.index + ' ' + data.name,
                'virtualPageTitle': 'Order Step ' + data.index + ' – ' + data.name
            };
            var checkout = {
                'event': 'checkout',
                'ecommerce': {
                    'checkout': {
                        'actionField': {
                            'step': data.index
                        }
                    }
                }
            };

            e4.gtm.pushDataLayer( virtualPageview );
            e4.gtm.pushDataLayer( checkout );
        },
        init: function () {}
    }
};

